"use client";

import axios from "axios";
import { initialize, InitializeResult } from "@open-iframe-resizer/core";
// import iFrameResize from 'iframe-resizer'

export type IFrameHtmlBuilderOptions = {
    iframeId:string,
}
export type IFrameHtmlBuilder = (content: string, options?:IFrameHtmlBuilderOptions) => string;
export class IFrameContainer {
    private container: HTMLDivElement;
    private iframe: HTMLIFrameElement;
    private readonly iframeId: string;
    private minWidth: number | null = null;
    private minHeight: number | null = null;
    private maxWidth: number | null = null;
    private maxHeight: number | null = null;
    private currentLoadCallback: (() => void) | null = null;
    private currentErrorCallback: ((error: Error) => void) | null = null;
    private resizeEnabled: boolean = true;
    private initializeResultList?: InitializeResult[];
    private blobUrl?:string
    
    // 保存原始状态的对象
    private originalState: {
        position?: string;
        top?: string;
        left?: string;
        width?: string;
        height?: string; 
        zIndex?: string;
        overflow?: string;
        border?: string;
        margin?: string;
        padding?: string;
        boxSizing?: string;
        minWidth?: number | null;
        minHeight?: number | null;
        maxWidth?: number | null;
        maxHeight?: number | null;
        isFullscreen: boolean;
    } = { isFullscreen: false };
    

    constructor() {
        this.iframeId = 'iframe_' + Math.random().toString(36).substr(2, 9);
        
        // 创建容器和iframe
        this.container = document.createElement('div');
        this.iframe = document.createElement('iframe');
        (this.iframe as any).controller = this;
        // 设置容器样式
        this.container.style.width = '100%';
        this.container.style.height = '100%';
        this.container.style.overflow = 'hidden';
        this.container.style.position = 'relative';
        this.container.style.maxWidth = '100%';
        this.container.style.margin = '0 auto';
        
        // 设置iframe样式
        this.iframe.style.width = '100%';
        this.iframe.style.height = '100%';
        this.iframe.style.border = 'none';
        this.iframe.style.overflow = 'hidden';
        this.iframe.style.boxSizing = 'border-box';
        this.iframe.setAttribute('scrolling', 'no');
        this.iframe.setAttribute('seamless', 'seamless');

        // --- Add Load and Error Handlers ---
        this.iframe.onload = () => {
            if (this.currentLoadCallback) {
                this.currentLoadCallback();
                // Optionally clear callback after use if needed
                // this.currentLoadCallback = null; 
            }
            if(typeof window !== 'undefined' ) {
                this.fitIframe();
                // const initInitialize = ()=>{
                //     const list:InitializeResult[] = initialize({
                //         bodyMargin:"0px",
                //         bodyPadding:"0px",
                //         offsetSize:3,
                //     },`#${this.iframeId}`)
                // }
                // initInitialize();

                // const initIframeResizer =()=>{
                //     const iFrameResize = (window as any).iframeResize;
                //     // console.log('iframeResize_fn', iFrameResize)
                //     iFrameResize({
                //         onReady:(iframe:any)=>{
                //             // console.log('onReady_fn', iframe)
                //         },
                //         license: 'GPLv3',
                //         waitForLoad:true,
                //         log: false, // 可选：是否输出日志
                //         checkOrigin: false, // 可选：如果 iframe 是跨域的必须设为 false
                //       }, `#${this.iframeId}`);
                    
                // }
            }
        };

        this.iframe.onerror = (event: Event | string, source?: string, lineno?: number, colno?: number, error?: Error) => {
            console.error('%cIFrameContainer: iframe "error" event triggered.', 'color: red; font-weight: bold;', event);
            const err = error || new Error(typeof event === 'string' ? event : 'Failed to load iframe content');
            if (this.currentErrorCallback) {
                this.currentErrorCallback(err);
                // Optionally clear callback after use if needed
                // this.currentErrorCallback = null;
            }
        };
        // --- End Handlers ---

        // 将iframe添加到容器中
        this.container.appendChild(this.iframe);
        
        // 设置iframe的ID
        this.iframe.id = this.iframeId;
        
        // 添加message事件监听
        window.addEventListener('message', this.handleIframeMessage.bind(this));
    }
    // private initializeResultList?:InitializeResult[]
    private fitIframe(){
        return;
        this.initializeResultList = initialize({
            bodyMargin:"0px",
            bodyPadding:"0px",
            offsetSize:3,
        },`#${this.iframeId}`);
    }
    public loadContent(content: string, htmlBuilder?:IFrameHtmlBuilder): void {
        this.currentLoadCallback = null;
        this.currentErrorCallback = null;
        const resizeScript = `
            <script>
                const IFRAME_ID = '${this.iframeId}';
                window.IFRAME_ID = '${this.iframeId}';
                function notifyResize() {
                    const body = document.body;
                    const html = document.documentElement;
                    
                    // 获取实际内容高度（取最大值）
                    const height = Math.max(
                        body.scrollHeight,
                        body.offsetHeight,
                        html.scrollHeight,
                        html.offsetHeight
                    );
                    
                    // 获取实际内容宽度
                    const width = Math.max(
                        body.scrollWidth,
                        body.offsetWidth,
                        html.scrollWidth,
                        html.offsetWidth
                    );
                    
                    // 发送消息给父窗口
                    window.parent.postMessage({
                        type: 'resize',
                        iframeId: IFRAME_ID,
                        height,
                        width
                    }, '*');
                }
                
                // 监听窗口大小变化
                window.addEventListener('resize', notifyResize);
                
                // 监听DOMContentLoaded，确保DOM加载完毕后调整大小
                document.addEventListener('DOMContentLoaded', notifyResize);
                
                // 监听load事件，确保所有资源加载完毕后调整大小
                window.addEventListener('load', notifyResize);
                
                // 创建MutationObserver监听DOM变化
                const observer = new MutationObserver(notifyResize);
                observer.observe(document.documentElement, {
                    childList: true,
                    subtree: true,
                    attributes: true,
                    characterData: true
                });
                
                // 监听来自父窗口的消息，处理请求重新调整大小的消息
                window.addEventListener('message', function(event) {
                    if (event.data && event.data.type === 'requestResize') {
                        // 主动触发一次尺寸计算和发送
                        notifyResize();
                    }
                });
                
                // 初始化大小
                notifyResize();
            </script>
        `;

        const topScript = `
        <script>
        var autoWebViewJs = window.autoWebViewJs = window.parent.window.autoWebViewJs;
        autoWebViewJs = window.parent.window.autoWebViewJs;
        var isRealInAndroid = window.isRealInAndroid;
        var storeUtilsConf = window.storeUtilsConf = window.parent.window.storeUtilsConf;
        </script>
        `
        const bodyStyle = `<style>html, body{margin-left:-4px;padding:0;
        background-color: white;}</style>`;

        const idScript = `
        <script>
            const IFRAME_ID = '${this.iframeId}';
            window.IFRAME_ID = '${this.iframeId}';
        </script>`

        // 将内容和脚本组合
        let fullContent = content;
        fullContent = fullContent.includes('<head>') ?
            fullContent.replace('<head>', `<head>${topScript}`)
            : `${fullContent}${topScript}`;

        fullContent = fullContent.includes('</head>') ?
            fullContent.replace('</head>', `${bodyStyle}</head>`)
            : `${fullContent}${bodyStyle}`;

        fullContent = fullContent.includes('</body>') 
            ? fullContent.replace('</body>', `${resizeScript}</body>`)
            : `${fullContent}${resizeScript}`;

        // fullContent = fullContent.includes('<head>') ?
        // fullContent.replace(`<head>`,`<head>${idScript}`):
        // `${idScript}${fullContent}`;

        let c = htmlBuilder ? htmlBuilder(content,{iframeId:this.iframeId}) : content;
        // c = c.includes('</body>') 
        //     ? c.replace('</body>', `${resizeScript}</body>`)
        //     : `${c}${resizeScript}`;

        // this.iframe.srcdoc = c

        const blob = new Blob([c], { type: 'text/html' });
        const url = URL.createObjectURL(blob);
        this.blobUrl = url;
        this.iframe.src = url;
    }
    private template(s:string){
        return `
        <html>
        <head>
        </head>
        <body>
        <div id="app"></div>
        <script>${s}</script>
        </body>
        </html>`
    }
    /**
     * 设置最小宽度和高度
     * @param minWidth 最小宽度（像素）
     * @param minHeight 最小高度（像素）
     */
    public setMinSize(minWidth: number | null, minHeight: number | null): void {
        this.minWidth = minWidth;
        this.minHeight = minHeight;
    }

    /**
     * 设置最大宽度和高度
     * @param maxWidth 最大宽度（像素）
     * @param maxHeight 最大高度（像素）
     */
    public setMaxSize(maxWidth: number | null, maxHeight: number | null): void {
        this.maxWidth = maxWidth;
        this.maxHeight = maxHeight;
    }

    private handleIframeMessage(event: MessageEvent): void {
        // 如果禁用了调整大小功能或处于全屏状态，直接返回
        if (!this.resizeEnabled || this.originalState.isFullscreen) return;
        if (event.data.type === 'resize' && event.data.iframeId === this.iframeId) {
            let { height, width } = event.data;
            const windowMaxWidth = window.innerWidth;
            
            // 应用最小尺寸限制
            if (this.minWidth !== null) {
                width = Math.max(width, this.minWidth);
            }
            if (this.minHeight !== null) {
                height = Math.max(height, this.minHeight);
            }
            
            // 应用最大尺寸限制
            if (this.maxWidth !== null) {
                width = Math.min(width, this.maxWidth);
            } else {
                // 如果没有设置最大宽度，则使用窗口宽度作为限制
                width = Math.min(width, windowMaxWidth);
            }
            
            if (this.maxHeight !== null) {
                height = Math.min(height, this.maxHeight);
            }
            
            // 设置容器尺寸
            this.container.style.height = `${height}px`;
            this.container.style.width = `${width}px`;
        }
    }

    /**
     * 通过URL加载iframe
     * @param url 要加载的URL
     * @param onLoad 加载成功回调函数
     * @param onError 加载失败回调函数
     */
    public async loadUrl(url: string, onLoad?: () => void, onError?: (error: Error) => void) {
        this.currentLoadCallback = onLoad || null;
        this.currentErrorCallback = onError || null;
        if (this.iframe) {
            this.iframe.src = url;
        } else {
            console.error('IFrameContainer: iframe element is null in loadUrl!');
        }
    }

    // 移除 createLoadingElement, showLoading, removeLoading 方法

    /**
     * 从URL加载内容并作为字符串显示
     * @param url 要加载的资源URL
     * @returns Promise<void>
     */
    public async loadUrlAsContent(url: string, onLoad?: () => void, onError?: (error: Error) => void, htmlBuilder?:IFrameHtmlBuilder): Promise<void> {
        console.log('llllllllllllllload')
        try {
            const response = await fetch(url);
            if (!response.ok) {
                onError?.(new Error(`HTTP error! status: ${response.status}`));
                return;
            }
            console.log('loaded')
            const content = await response.text();
            this.loadContent(content, htmlBuilder);
            onLoad?.();
        } catch (error) {
            console.error('Failed to load URL content:', error);
            onError?.(error as Error);
        }
    }

    /**
     * 获取容器元素
     * @returns HTMLDivElement 容器元素
     */
    public getContainer(): HTMLDivElement {
        return this.container;
    }

    /**
     * 设置容器大小
     * @param width 宽度
     * @param height 高度
     */
    public setSize(width: string, height: string): void {
        this.container.style.width = width;
        this.container.style.height = height;
    }
    
    /**
     * 进入全屏模式
     * 将iframe扩展到整个窗口大小，并暂停自动调整大小
     */
    public enterFullscreen(): void {
        if (this.originalState.isFullscreen) return; // 已经是全屏了
        
        // 保存当前状态
        this.originalState = {
            position: this.container.style.position,
            top: this.container.style.top,
            left: this.container.style.left,
            width: this.container.style.width,
            height: this.container.style.height,
            zIndex: this.container.style.zIndex,
            overflow: this.container.style.overflow,
            border: this.container.style.border,
            margin: this.container.style.margin,
            padding: this.container.style.padding,
            boxSizing: this.container.style.boxSizing,
            minWidth: this.minWidth,
            minHeight: this.minHeight,
            maxWidth: this.maxWidth,
            maxHeight: this.maxHeight,
            isFullscreen: true
        };
        
        // 暂停resize功能
        this.resizeEnabled = false;
        
        // 设置全屏样式
        this.container.style.position = 'fixed';
        this.container.style.top = '0';
        this.container.style.left = '0';
        this.container.style.width = '100vw';
        this.container.style.height = '100vh';
        this.container.style.zIndex = '2147483647';
        this.container.style.border = 'none';
        this.container.style.margin = '0';
        this.container.style.padding = '0';
        this.container.style.boxSizing = 'border-box';
        
        // 临时禁用最小/最大尺寸限制
        this.setMinSize(null, null);
        this.setMaxSize(null, null);
    }
    
    /**
     * 退出全屏模式
     * 恢复iframe到原始大小，并重新启用自动调整大小
     */
    public exitFullscreen(): void {
        if (!this.originalState.isFullscreen) return; // 不是全屏状态
        
        // 恢复原来的样式
        this.container.style.position = this.originalState.position || '';
        this.container.style.top = this.originalState.top || '';
        this.container.style.left = this.originalState.left || '';
        this.container.style.width = this.originalState.width || '';
        this.container.style.height = this.originalState.height || '';
        this.container.style.zIndex = this.originalState.zIndex || '';
        this.container.style.overflow = this.originalState.overflow || '';
        this.container.style.border = this.originalState.border || '';
        this.container.style.margin = this.originalState.margin || '';
        this.container.style.padding = this.originalState.padding || '';
        this.container.style.boxSizing = this.originalState.boxSizing || '';
        
        // 恢复最小/最大尺寸限制
        this.setMinSize(this.originalState.minWidth ?? null, this.originalState.minHeight ?? null);
        this.setMaxSize(this.originalState.maxWidth ?? null, this.originalState.maxHeight ?? null);
        
        // 重新启用resize功能
        this.resizeEnabled = true;
        
        // 重置状态
        this.originalState.isFullscreen = false;
        
        // 触发一次resize以恢复适当的大小
        if (this.iframe.contentWindow) {
            // 尝试通过消息触发重新调整大小
            this.iframe.contentWindow.postMessage({ type: 'requestResize' }, '*');
        }
    }
    
    /**
     * 切换全屏状态
     * 如果当前是全屏，则退出；否则进入全屏
     */
    public toggleFullscreen(): void {
        if (this.originalState.isFullscreen) {
            this.exitFullscreen();
        } else {
            this.enterFullscreen();
        }
    }
    
    /**
     * 判断是否是全屏状态
     * @returns boolean 是否处于全屏状态
     */
    public isFullscreen(): boolean {
        return this.originalState.isFullscreen;
    }
    
    /**
     * 启用或禁用resize功能
     * @param enabled 是否启用resize
     */
    public enableResize(enabled: boolean): void {
        this.resizeEnabled = enabled;
        
        // 如果重新启用了resize，尝试触发一次调整大小
        if (enabled && this.iframe.contentWindow && !this.originalState.isFullscreen) {
            this.iframe.contentWindow.postMessage({ type: 'requestResize' }, '*');
        }
    }

    public exit(){
        const iframe = this.iframe;
        if(!iframe)return;
        const clone = iframe.cloneNode(false);
        iframe.replaceWith(clone);
        iframe.remove();
        if(this.blobUrl){
            URL.revokeObjectURL(this.blobUrl);
            this.blobUrl = undefined;
        }
        console.log('iframe released', this.iframeId)
    }
}